import { findParentPathFromLeftSideMenu } from './lnbUtil';
import { removeSlashPath } from './pathUtil';

export const findActiveNavigation = (data, pathname) => {
  if (!data) return [];
  const normalizedPathname = removeSlashPath(pathname);

  const traverse = (items, targetPath) => {
    for (const item of items) {
      if (item.content && item.content.length > 0) {
        const childResult = traverse(item.content, targetPath);
        if (childResult) {
          return [{ title: item.title, path: '' }, ...childResult];
        }
      }

      const itemPath = removeSlashPath(
        item.path ? item.path.split('?')[0] : ''
      );

      if (itemPath === targetPath) {
        return [{ title: item.title, path: item.path || '' }];
      }
    }
    return null;
  };

  // 모바일인 경우 (data가 배열)
  if (Array.isArray(data)) {
    // 1. 기본 탐색
    let breadcrumb = traverse(data, normalizedPathname);

    // 2. LeftSideMenu 그룹 실패 시 부모 경로로 재탐색
    if (!breadcrumb) {
      const parentPath = findParentPathFromLeftSideMenu(pathname);
      if (parentPath) {
        breadcrumb = traverse(data, removeSlashPath(parentPath));
      }
    }

    // 3. APP 상세 페이지 처리
    if (!breadcrumb) {
      const appMatch = normalizedPathname.match(/^\/app\/\d+\/([^/?#]+)/);
      if (appMatch) {
        const parentPath = '/app';
        // 모바일 메뉴 구조에서 /app 경로를 가진 항목을 찾아서 traverse 시작
        // (보통 traverse(data, ...) 로 해결됨)
        const parentBreadcrumb = traverse(data, parentPath);
        if (parentBreadcrumb) {
          const appName = decodeURIComponent(appMatch[1]);
          breadcrumb = [...parentBreadcrumb, { title: appName, path: '' }];
        }
      }
    }

    return breadcrumb || [];
  }

  // PC인 경우 (data가 객체)
  const root = {
    title: data.title,
    path: data.path || '',
  };

  // 1. 기본 탐색
  let breadcrumb = traverse(data.lnb || [], normalizedPathname);

  // 2. LeftSideMenu 그룹에 속한 경우 부모 경로로 찾기
  if (!breadcrumb) {
    const parentPath = findParentPathFromLeftSideMenu(pathname);
    if (parentPath) {
      breadcrumb = traverse(data.lnb || [], removeSlashPath(parentPath));
    }
  }

  // 3. APP 상세 페이지 (예: /app/:idx/:name) 처리
  // 패턴: /app/<숫자>/<이름>
  if (!breadcrumb) {
    const appMatch = normalizedPathname.match(/^\/app\/\d+\/([^/?#]+)/);
    if (appMatch) {
      const parentPath = '/app';
      const parentBreadcrumb = traverse(data.lnb || [], parentPath);
      if (parentBreadcrumb) {
        const appName = decodeURIComponent(appMatch[1]);
        breadcrumb = [...parentBreadcrumb, { title: appName, path: '' }];
      }
    }
  }

  if (breadcrumb) {
    return [root, ...breadcrumb];
  }

  return [root];
};
